import { PillarOfOopsWrapper } from './4PillarOfOops.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import EmbedYoutube from '../../utils/EmbedYoutube/EmbedYoutube';
import { Accordion, AccordionItem, AccordionHeader, AccordionBody } from 'reactstrap';
import { useState } from 'react';
import interviewQna from './../../../resources/content/interviewQna.png';
import pillars1 from './../../../resources/content/pillars1.png';
import pillars2 from './../../../resources/content/pillars2.png';

function PillarOfOops() {

  const [open, setOpen] = useState('');
  const toggle = (id: any) => {
    if (open === id) {
      setOpen('');
    } else {
      setOpen(id);
    }
  };

  return(
    <PillarOfOopsWrapper>
      <header className="entry-header ">
        <h1 className="entry-title" itemProp="headline">4 Pillars of OOPS</h1>			
      </header>
      <br/>
      <div className="entry-content clear" itemProp="text"  style={{height: 'auto !important'}}>
        <h4 className="text-align-justify has-primary-color has-text-color">Inheritance :</h4>

        <div>
          <div className="is-layout-flow">
            <ul className="text-align-justify">
              <li>It is a concept where one class acquires the property of another class.</li>
              <li>Above all, it supports the concept of re-usability.</li>
              <li>Inheritance represents the IS-A relationship. So it is also known as a parent-child relationship.</li>
              <li>To implement inheritance, we use the “extends” keyword.</li>
              <li>It helps to increase the functionality by making a new class that derives from an existing class.</li>
              <li>In other words, the subclass is one that inherits from another class, and the superclass is the one from which it inherits.</li>
              <li><strong>Syntax :</strong></li>
                
              <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
              {
                'class Sub - className extends Super - className {\n'+
                '  //methods and fields \n'+
                '}'
              }
              </SyntaxHighlighter>
              <li>Example :</li>
              <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
              {
                'class Calculate {\n'+
                '  protected int num1 = 5;\n'+
                '  public void printSum() {\n'+
                '    System.out.println(num1);\n'+
                '  }\n'+
                '}\n'+
                '\n'+
                'class Add extends Calculate {\n'+
                '  private int num2 = 10;\n'+
                '  public static void main(String args[]) {\n'+
                '    Add add = new Add();\n'+
                '    add.printSum();\n'+
                '    System.out.println("Total = " + add.num1 + add.num2);\n'+
                '  }\n'+
                '}'
              }
              </SyntaxHighlighter>
            </ul>
          </div>
        </div>
        <br/>
        <ul  className="text-align-justify">
          <li>Inheritance is of four types :
            <ul>
              <li><strong>Single Inheritance:&nbsp;</strong>In Single Inheritance, a class inherits the properties of another class.</li>
              <li><strong>Multilevel Inheritance:</strong>&nbsp;In Multilevel Inheritance, a class is derived from another class, which in return is also derived from another class, i.e., a class having more than one parent class but at different levels.</li>
              <li><strong>Hierarchical Inheritance:</strong>&nbsp;In Hierarchical Inheritance, a class has more than one child class.</li>
              <li><strong>Hybrid Inheritance:</strong>&nbsp;In Hybrid Inheritance, a combination of multiple inheritance and multilevel inheritance is seen. It means there will be multiple parent classes and multiple child classes.</li>
            </ul>
          </li>
        </ul>

        <div>
          <figure className="aligncenter size-large">
            <img decoding="async" width="755" height="485" src={pillars1} alt="" className="lazy-loaded" sizes="(max-width: 755px) 100vw, 755px" />
          </figure>
        </div>
        <br/>
        <h4  className="text-align-justify">Encapsulation :</h4>
        <ul  className="text-align-justify">
          <li>It is a concept of binding of data and methods within a single unit.</li>
          <li>It acts as a protective shield. As a result, the outside world cannot access the data.</li>
          <li>Above all, it is a way to achieve data hiding + Abstraction together.</li>
          <li>Therefore, the other classes are not able to access the data through their private data members.</li>
          <li>Since it is declared as private, implementation details are also hidden from the end-user.</li>
          <li>For instance, a java class is an example of encapsulation as it wraps up the properties and methods together.</li>
          <li>Example :</li>
          <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
          {
            'public Class Person {\n'+
            '  private String name;\n'+
            '  public String getName() {\n'+
            '    return name;\n'+
            '  }\n'+
            '  public void setName(String newName) {\n'+
            '    this.name = newName;\n'+
            '  }\n'+
            '}'
          }
          </SyntaxHighlighter>
        </ul>
        <br/>
        <h4  className="text-align-justify">Abstraction :</h4>
        <ul  className="text-align-justify">
          <li>It is a concept where it displays only the essential information and hides the details.</li>
          <li>Therefore, it helps to reduce programming complexity and effort.</li>
          <li>We can achieve Abstraction using abstract classes and interfaces.</li>
          <li>An abstract class only contains one or more abstract methods(method with nobody).</li>
          <li>A class that extends an abstract class can override its abstract methods.</li>
          <li>An interface is a reference type that determines the model of the class that implements it. All methods declared in it are abstract by default.</li>
          <li>To implement an interface, we use the “implements” keyword.</li>
          <li>Example :</li>
          <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
          {
            '// Abstraction by abstract class\n'+
            '\n'+
            'abstract class Animal {\n'+
            '  public abstract void display() {\n'+
            '    System.out.println("Animal");\n'+
            '  }\n'+
            '}\n'+
            '\n'+
            'class Cat extends Animal {\n'+
            '  public void display() {\n'+
            '    System.out.println("Cat");\n'+
            '  }\n'+
            '}\n'+
            '\n'+
            'class MainClass {\n'+
            '  public static void main(String args[]) {\n'+
            '    Cat cat = new Cat();\n'+
            '    cat.display();\n'+
            '  }\n'+
            '}'
          }
          </SyntaxHighlighter>
          <br/>
          <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
          {
            '// Abstraction by interface\n'+
            '\n'+
            'interface Vehicle {\n'+
            '  void display();\n'+
            '}\n'+
            '\n'+
            'class Car implements Vehicle {\n'+
            '  public void display() {\n'+
            '    System.out.println("Car");\n'+
            '  }\n'+
            '}\n'+
            '\n'+
            'class Bike extends Vehicle {\n'+
            '  public void display() {\n'+
            '    System.out.println("Bike");\n'+
            '  }\n'+
            '}\n'+
            '\n'+
            'class MainClass {\n'+
            '  public static void main(String args[]) {\n'+
            '    Vehicle car = new Car();\n'+
            '    car.display();\n'+
            '    Vehicle bike = new Bike();\n'+
            '    bike.display();\n'+
            '  }\n'+
            '}'
          }
          </SyntaxHighlighter>
        </ul>
        <br/>
        <h4  className="text-align-justify">Polymorphism :</h4>
        <ul  className="text-align-justify">
          <li>To achieve Polymorphism, satisfy below three conditions :
            <ul>
              <li>An object can exist in many forms.</li>
              <li>All forms should reside within a single unit.</li>
              <li>Which form will be executed depends on the input.</li>
            </ul>
          </li>
          <li>It is mainly of two types :
            <ul>
              <li>
                <strong>Compile Time/ Static binding </strong>– Method Overloading
                <ul>
                  <li><strong>Method overloading</strong> is when multiple methods with the same name but different signature exist in a class. A different signature means a different number of parameters or different parameter datatype or a different sequence of parameters.</li>
                </ul>
              </li>
              <li>
                <strong>Run Time/ Dynamic binding </strong>– Method Overriding
                <ul>
                  <li><strong>Method Overriding</strong> is redefining a method of the superclass in a subclass.</li>
                </ul>
              </li>
            </ul>
          </li>
          <li>Example :</li>
          <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
          {
            'class Animal {\n'+
            '  public void display() {\n'+
            '    System.out.println("Animal");\n'+
            '  }\n'+
            '}\n'+
            'class Cat extends Animal {\n'+
            '  public void display() {\n'+
            '    System.out.println("Cat");\n'+
            '  }\n'+
            '}\n'+
            'class Dog extends Animal {\n'+
            '  public void display() {\n'+
            '    System.out.println("Dog");\n'+
            '  }\n'+
            '}\n'+
            '\n'+
            'class MainClass {\n'+
            '  public static void main(String args[]) {\n'+
            '    Animal animal = new Animal();\n'+
            '    Animal cat = new Cat();\n'+
            '    Animal dog = new Dog();\n'+
            '\n'+
            '    animal.display();\n'+
            '    cat.display();\n'+
            '    dog.display();\n'+
            '  }\n'+
            '}'
          }
          </SyntaxHighlighter>
        </ul>
        
        <br/>
        <EmbedYoutube videoType="video" videoList={["UQ9JOV9z6ko"]} />
        <br/>
        <div>
          <figure className="aligncenter size-large">
            <img decoding="async" width="641" height="408" src={interviewQna} alt="" className="lazy-loaded" sizes="auto, (max-width: 641px) 100vw, 641px" />
          </figure>
        </div>

        <Accordion open={open} toggle={toggle}>
            <AccordionItem>
              <AccordionHeader targetId="1">
                <span className="fa fa-book"></span>
                <span style={{marginLeft: '3vw'}}>What is runtime polymorphism?</span>
              </AccordionHeader>
              <AccordionBody accordionId="1">
                <p className="text-align-justify">Runtime Polymorphism is the dynamic binding that happens at runtime. For instance, method overriding. <strong>Method Overriding</strong> is redefining a method of the superclass in a subclass.</p>
              </AccordionBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionHeader targetId="2">
                <span className="fa fa-book"></span>
                <span style={{marginLeft: '3vw'}}>What is method overloading and method overriding?</span>
              </AccordionHeader>
              <AccordionBody accordionId="2">
                <ul className="text-align-justify">
                  <li><strong>Method overloading</strong> is when multiple methods with the same name but different signature exist in a class. A different signature means a different number of parameters or different parameter datatype or a different sequence of parameters.</li>
                  <li><strong>Method Overriding</strong> is redefining a method of the superclass in a subclass.</li>
                </ul>
              </AccordionBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionHeader targetId="3">
                <span className="fa fa-book"></span>
                <span style={{marginLeft: '3vw'}}>What is multiple inheritance? Is it supported in Java?</span>
              </AccordionHeader>
              <AccordionBody accordionId="3">
              <p className="text-align-justify"><strong>Multiple inheritance </strong>is where one can have multiple parent classes but just one child class. </p>
              <p className="text-align-justify">This concept is not supported in Java. Because it leads to ambiguity, so this type of inheritance can only be achieved through the use of interfaces.</p>
              <div>
                <figure className="aligncenter size-medium">
                  <img decoding="async" width="300" height="253" src={pillars2} alt="" sizes="auto, (max-width: 300px) 100vw, 300px" />
                  <figcaption>Ambiguity – Which version of A should D use, the one provided by B or C?</figcaption>
                </figure>
              </div>
              </AccordionBody>
            </AccordionItem>
          </Accordion>
    </div>
  </PillarOfOopsWrapper>
  )
};

export default PillarOfOops;

